<div class="ntt-dropdown-menu-divider"></div>
